/**
 * Created by renjie.huang on 2017/11/8.
 */

var request = require('../common/request');
var Promise = require('promise');
var action = require('../common/action');
var _ = require('_');

var service = {
    loginByWeChat : (data)=>{
        var promise = new Promise(function(resolve,reject){
            // console.log('request');
            request(action.login.loginByWechat,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data)
            })
        })

        return promise;
    },

    loginByTOTP : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.loginByTOTP,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },

    checkLoginTOTP : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.checkLoginTOTP,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },

    phoneLoginByTOTP: (data) => {
        var promise = new Promise(function(resolve,reject){
            request(action.login.LoginBySms,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },

    sendPhoneVerifyCode : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.sendPhoneVerifyCode,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },
    
    sendEmailVerifyCode : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.sendEmailVerifyCode,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },

    sendPhoneVerificationCodeV2 : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.SendPhoneVerificationCodeV2,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },

    sendRestPasswordEmailCode : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.SendResetPasswordEmail,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },

    resetPassword : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.register.resetPassword,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })
        return promise;
    },

    checkVerifyCode : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.checkEmailCodeByEmailKey,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })

        return promise;
    },

    getEmailByKey: (data) => {
        return new Promise((resolve, reject) => {
            request(action.login.getEmailByKey, data).success((data) => {
                resolve(data);
            }).fail((data) => {
                reject(data);
            })
        })
    },
    getPasswordPolicyForResetPassword:(data)=>{
        return new Promise((resolve, reject) => {
            request(action.login.GetPasswordPolicyForResetPassword, data).success((data) => {
                resolve(data);
            }).fail((data) => {
                reject(data);
            })
        })
    }
}

module.exports = {
    loginByWeChat : service.loginByWeChat,
    sendPhoneVerifyCode : service.sendPhoneVerifyCode,
    sendRestPasswordEmailCode : service.sendRestPasswordEmailCode,
    resetPassword : service.resetPassword,
    checkVerifyCode : service.checkVerifyCode,
    loginByTOTP : service.loginByTOTP,
    checkLoginTOTP: service.checkLoginTOTP,
    getEmailByKey: service.getEmailByKey,
    sendPhoneVerificationCodeV2: service.sendPhoneVerificationCodeV2,
    phoneLoginByTOTP: service.phoneLoginByTOTP,
    getPasswordPolicyForResetPassword: service.getPasswordPolicyForResetPassword
}


// WEBPACK FOOTER //
// src/service/loginService.js